import { Link, useLocation } from "react-router-dom";

// Fixed bottom navigation for phones. Hosts the same two
// dashboard-chrome actions (Email templates, Volunteers) that
// desktop renders inline with the greeting, freeing the top
// real estate on small screens. Hidden on tablets+ via CSS.
//
// Both links pass `backgroundLocation` so the targets open as
// modals on top of whatever page Colleen is on — same behavior
// as the desktop pills.
export default function BottomTabBar() {
  const location = useLocation();
  return (
    <nav className="bottom-tab-bar" aria-label="Primary actions">
      <Link
        to="/templates"
        state={{ backgroundLocation: location }}
        className="bottom-tab-bar__item"
      >
        <EnvelopeIcon />
        <span>Email templates</span>
      </Link>
      <Link
        to="/volunteers"
        state={{ backgroundLocation: location }}
        className="bottom-tab-bar__item"
      >
        <VolunteersIcon />
        <span>Volunteers</span>
      </Link>
    </nav>
  );
}

function EnvelopeIcon() {
  return (
    <svg viewBox="0 0 18 18" width="22" height="22" aria-hidden="true">
      <rect
        x="2"
        y="4"
        width="14"
        height="10"
        rx="1.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M2.5 5 L9 10 L15.5 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function VolunteersIcon() {
  return (
    <svg viewBox="0 0 18 18" width="22" height="22" aria-hidden="true">
      <circle cx="6.5" cy="6.5" r="2.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M2 14.5 c0 -2.6 2 -4 4.5 -4 c2.5 0 4.5 1.4 4.5 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle cx="13" cy="7" r="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M10.5 14.5 c0.2 -2.1 1.6 -3.2 3 -3.2 c1.5 0 2.7 1 2.7 3.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
